import { CloseIcon } from '@/utils/icons'
import s from './ChatMessage.module.css'
import { FileView } from '@common/Chat/components/FileView/FileView'
import classNames from 'classnames'
import { chatApi } from '@/api'
import { useAddAlert } from '@/hooks/useAddAlert'
import { MessageView } from './ChatMessage'
import Moment from 'react-moment'
import { useState } from 'react'
import { useSelector } from 'react-redux'
import { convertPlatformDateTimeToUser } from '@/helpers/new/time/platformTimeConversion'

export const DelayedMessage = ({message, getDelayedMessages}) => {
    const [isDeletion, setIsDeletion] = useState(false);
    const addAlert = useAddAlert();
    const platformTime = useSelector((store) => store.platformTime);

    const getSendAtByUserTime = () => {
        if (!message?.send_at || platformTime?.status !== 'success') {
            return message?.send_at;
        }

        const converted = convertPlatformDateTimeToUser({
            dateTime: message.send_at,
            platformTime: platformTime?.platformTime,
        });

        return converted ? converted.toDate() : message?.send_at;
    }
    const deleteDelayedMessage = () => {
        if(!message.id || isDeletion){
            return;
        }

        setIsDeletion(true)
        
        chatApi.deleteScheduledMessages({id: message.id})
            .then(({data}) => {
                if(data?.status === 'success'){
                    addAlert({title: 'Успешно', text: 'Сообщение удалено из отложенных'})
                    getDelayedMessages?.()
                }
                else{
                    addAlert({title: 'Ошибка', text: 'При удалении отложенного сообщения произошла ошибка', type: 'error'})
                }
            })
            .finally(() => setIsDeletion(false))
    }

    return (
        <div className={classNames(s.message)}>
            <div className={s.delayedMessageHeader}>
                <div className={s.date}>
                    <Moment locale="ru" date={getSendAtByUserTime()} format="[Отправится] D MMM YYYY [в] k:mm"  withTitle />
                </div>
                
                <button 
                    onClick={deleteDelayedMessage}
                    className={s.deleteIcon}
                    type='button'>
                        <CloseIcon />
                </button>
            </div>
            <MessageView message={message.message} isAuthor />
            <FileView files={message?.files} isAutor />
        </div>
    )
}
